import { useEffect, type ReactNode } from "react";
import { useMapStore } from "@/stores/mapStore";

interface EntityChipProps {
  entityType: string;
  entityId: string;
  children: ReactNode;
  onClick: (entityType: string, entityId: string, name: string) => void;
}

export function EntityChip({ entityType, entityId, children, onClick }: EntityChipProps) {
  const setHoveredEntityId = useMapStore((s) => s.setHoveredEntityId);
  const revealEntity = useMapStore((s) => s.revealEntity);
  const mapIntent = useMapStore((s) => s.mapIntent);

  // Progressive reveal: when this chip mounts during analysis mode, reveal its entity on the map
  useEffect(() => {
    if (mapIntent?.mode === "analysis") {
      revealEntity(entityId);
    }
  }, [entityId, mapIntent, revealEntity]);

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const name = typeof children === "string" ? children : (e.currentTarget.textContent ?? entityId);
        onClick(entityType, entityId, name);
      }}
      onMouseEnter={() => setHoveredEntityId(entityId)}
      onMouseLeave={() => setHoveredEntityId(null)}
      className="cx-entity-chip"
    >
      {children}
    </button>
  );
}
